import React from 'react';

export const ProductCardSkeleton = () => (
  <div className="animate-pulse rounded-xl border border-gray-200 bg-white p-3" data-testid="product-card-skeleton">
    <div className="mb-3 aspect-square w-full rounded-lg bg-gray-200" />
    <div className="mb-2 h-3 w-1/3 rounded bg-gray-200" />
    <div className="mb-1.5 h-3.5 w-full rounded bg-gray-200" />
    <div className="mb-3 h-3.5 w-2/3 rounded bg-gray-200" />
    <div className="mb-3 h-5 w-1/2 rounded bg-gray-200" />
    <div className="h-9 w-full rounded-lg bg-gray-200" />
  </div>
);

export default ProductCardSkeleton;
